import { render, staticRenderFns } from "./border_left_text.vue?vue&type=template&id=25aeda6d&scoped=true"
import script from "./border_left_text.vue?vue&type=script&lang=js"
export * from "./border_left_text.vue?vue&type=script&lang=js"
import style0 from "./border_left_text.vue?vue&type=style&index=0&id=25aeda6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aeda6d",
  null
  
)

export default component.exports